// src/i18n/translations.js
//
// Albanian is the source of truth. Any key missing from en/de falls back
// to sq at lookup time, so a half-finished translation degrades to
// Albanian instead of printing a raw key on the page.

const sq = {
  lang: { sq: "Shqip", en: "Anglisht", de: "Gjermanisht" },

  nav: {
    home: "Ballina",
    products: "Produktet",
    studio: "Studio",
    about: "Rreth Nesh",
    contact: "Kontakt",
    cart: "Shporta",
    openMenu: "Hap menunë",
    closeMenu: "Mbyll menunë",
    tagline: "Distributor ekskluziv i LaBina® për Kosovë",
    language: "Zgjidhni gjuhën",
  },

  common: {
    loading: "Duke ngarkuar…",
    tryAgain: "Provo përsëri",
    clearFilters: "Pastro filtrat",
    showMore: "Shfaq më shumë",
    allShown: "Të gjitha {{count}} produktet janë shfaqur.",
    ofProducts: "{{shown}} nga {{total}} produkte",
    product: "produkt",
    products: "produkte",
    optional: "(opsionale)",
    close: "Mbyll",
    cancel: "Anulo",
    send: "Dërgo",
    sending: "Duke dërguar…",
    back: "Kthehu",
  },

  home: {
    heroLine1: "Pigmente",
    heroLine2: "gjermane.",
    heroLine3a: "Duar",
    heroLine3b: "shqiptare.",
    heroLead:
      "Distributor ekskluziv i LaBina® për Kosovë — dhe studio që punon çdo ditë me të njëjtat produkte që shet.",
    heroShop: "Dyqani",
    heroStudio: "Studio",
    statement1:
      "Furnizojmë artistët e Kosovës me pigmente, gjilpëra dhe materiale origjinale nga Gjermania.",
    statement2: "Dhe i përdorim vetë, çdo ditë, në studion tonë.",
    facts: {
      since: "Prodhim gjerman që nga",
      params: "Parametra laboratorikë",
      iron: "Okside hekuri",
      preservatives: "Pa konservues kimikë",
    },
    shopEyebrow: "Dyqani",
    shopTitle: "Gjeni atë që ju duhet",
    seeAll: "Të gjitha produktet",
    noResults: "Asnjë produkt nuk përputhet me kërkimin tuaj.",
    ctaTitle1: "Nuk jeni të sigurt",
    ctaTitle2: "për nuancën?",
    ctaText:
      "Na tregoni tipin e lëkurës dhe rezultatin që kërkon klientja juaj. Ju ndihmojmë ta zgjidhni para se të porosisni.",
    ctaButton: "Na kontaktoni",
  },

  studio: {
    introKicker: "Kaida Beauty Studio",
    introTitle1: "Nuk jemi vetëm",
    introTitle2: "furnizues.",
    introText:
      "Jemi studio që punon çdo ditë me këto produkte. Prandaj e dimë saktësisht çfarë rekomandojmë.",
    hint: "Vazhdoni të lëvizni",
    kickerStudio: "Studio",
    kickerShop: "Dyqani",
    book: "Rezervo termin",
    seeShop: "Shiko dyqanin",
    lashes: {
      title: "Qerpikët",
      lead: "Classic, Hybrid dhe Volume — të aplikuara qerpik për qerpik.",
      body: "Punojmë me materiale që i njohim deri në detaj, sepse janë të njëjtat që u furnizojmë artistëve të tjerë. Asnjë kompromis me ngjitësin, asnjë dëmtim i qerpikut natyral.",
      tags: ["Classic", "Hybrid", "Volume", "Refill"],
    },
    brows: {
      title: "Vetullat",
      lead: "Microblading, Powder Brows dhe teknika të kombinuara.",
      body: "Nuanca zgjidhet sipas tonit të lëkurës dhe ngjyrës natyrale të flokëve — nga e njëjta kartelë LaBina® që shesim. Rezultati zbehet natyrshëm, pa kthim në të kuqe apo gri.",
      tags: ["Microblading", "Powder Brows", "Combo", "Korrigjim"],
    },
    nails: {
      title: "Thonjtë",
      lead: "Manikyr, xhel dhe ndërtim — punë e pastër që zgjat.",
      body: "Materialet e thonjve nuk i shesim në dyqan; këtë shërbim e ofrojmë vetëm brenda studios. I njëjti standard higjiene dhe i njëjti kujdes si te çdo shërbim tjetër.",
      tags: ["Manikyr", "Xhel", "Ndërtim", "Dizajn"],
      note: "Vetëm shërbim në studio",
    },
    shop: {
      title: "Të njëjtat produkte",
      lead: "Çfarë përdorim për qerpikët dhe vetullat, e gjeni në dyqan.",
      body: "Nuk shesim asgjë që nuk e përdorim vetë. Pigmentet, gjilpërat dhe materialet janë origjinale, me deklaratë konformiteti dhe të testuara para çdo serie.",
      tags: ["Pigmente", "Gjilpëra", "Materiale"],
    },
  },

  filters: {
    searchPlaceholder: "Kërko produkt ose kod",
    searchLabel: "Kërko produkte",
    clearSearch: "Pastro kërkimin",
    categoryGroup: "Filtro sipas kategorisë",
    all: "Të gjitha",
    sortLabel: "Rendit produktet",
    sortCode: "Sipas kodit",
    sortName: "Sipas emrit",
    sortPriceAsc: "Çmimi: nga më i ulëti",
    sortPriceDesc: "Çmimi: nga më i larti",
  },

  shop: {
    eyebrow: "Katalogu",
    title: "Kartela e ngjyrave",
    lede: "Çdo produkt vjen me kodin e tij nga prodhuesi. Kërkoni sipas emrit ose kodit.",
    loadFailed: "Produktet nuk u ngarkuan.",
    noResultsFor: 'Asnjë rezultat për "{{query}}".',
    emptyCategory: "Ende nuk ka produkte në këtë kategori.",
    showMoreCount: "Shfaq më shumë ({{count}})",
  },

  product: {
    addToCart: "Shto në shportë",
    added: "U shtua",
    orderNow: "Porosit tani",
    viewProduct: "Shiko produktin",
    requestSample: "Kërko mostrën",
    sampleBadge: "Mostër",
    sampleOnRequest: "Vetëm me kërkesë",
    sampleFree: "Falas për profesionistë",
    sampleNote: "Mostër — vetëm me kërkesë",
    sampleExplain:
      "Mostrat u dedikohen artistëve dhe studiove profesionale. Dërgoni një kërkesë me të dhënat e biznesit tuaj dhe ju kontaktojmë për ta konfirmuar.",
    inStock: "Në stok",
    lowStock: "Vetëm {{count}} copë",
    lowStockLong: "Vetëm {{count}} copë në stok",
    outOfStock: "Pa stok për momentin",
    outTitle: "Ky produkt ka mbaruar për momentin.",
    outBody:
      "Furnizimi i radhës është në rrugë. {{link}} ose na kontaktoni në WhatsApp dhe ju njoftojmë sapo të kthehet në stok.",
    outLink: "Na shkruani",
    notFound: "Produkti nuk u gjet",
    notFoundBody: "Ky produkt mund të jetë hequr ose linku është i gabuar.",
    backToProducts: "Kthehu te produktet",
    related: "Produkte të ngjashme",
    decrease: "Zvogëlo sasinë",
    increase: "Rrit sasinë",
    assurancePay: "Pagesa bëhet me para në dorë gjatë dorëzimit.",
    assuranceShip: "Dërgesa në të gjithë Kosovën.",
    assuranceOriginal: "Produkt origjinal me deklaratë konformiteti.",
    assuranceReview: "Kërkesa shqyrtohet nga stafi ynë para dërgesës.",
    assuranceContact: "Ju kontaktojmë në numrin që lini në formular.",
  },

  cart: {
    title: "Shporta",
    empty: "Shporta juaj është bosh.",
    seeProducts: "Shiko produktet",
    remove: "Hiq nga shporta",
    removeShort: "Hiq",
    maxStock: "Maksimumi në stok: {{count}}",
    total: "Totali",
    shippingNote: "Transporti llogaritet gjatë porosisë.",
    checkout: "Vazhdo me porosinë",
  },

  checkout: {
    eyebrow: "Porosia",
    title: "Përfundoni porosinë",
    lede: "Nuk nevojitet kartë bankare. Pagesa bëhet me para në dorë kur ta merrni porosinë.",
    emptyTitle: "Shporta juaj është bosh",
    emptyBody:
      "Shtoni produktet që ju duhen dhe kthehuni këtu për ta përfunduar porosinë.",
    yourDetails: "Të dhënat tuaja",
    name: "Emri dhe mbiemri",
    phone: "Numri i telefonit",
    email: "Email",
    city: "Qyteti",
    address: "Adresa e plotë",
    addressPlaceholder: "Rruga, numri, hyrja",
    note: "Shënim",
    notePlaceholder: "Orari kur jeni në shtëpi, udhëzime për dorëzim…",
    submit: "Dërgo porosinë",
    consent:
      "Duke dërguar porosinë, pranoni që stafi ynë t'ju kontaktojë për konfirmim.",
    summary: "Përmbledhja",
    subtotal: "Nëntotali",
    shipping: "Transporti",
    shippingValue: "Konfirmohet me telefon",
    stockChanged: "Stoku ndryshoi ndërkohë.",
    stockLine: "{{name}}: kërkuat {{requested}}, kanë mbetur {{available}}.",
    stockFix: "Rregulloni sasitë më poshtë dhe provoni përsëri.",
    failed: "Porosia nuk u dërgua. Provoni përsëri ose na telefononi.",
    errName: "Shkruani emrin dhe mbiemrin.",
    errPhone: "Numri duhet të jetë si 044 123 456.",
    errEmail: "Email-i nuk duket i saktë.",
    errCity: "Shkruani qytetin.",
    errAddress: "Shkruani adresën e plotë.",
    qtyFor: "Sasia për {{name}}",
  },

  success: {
    thanksNamed: "Faleminderit, {{name}}!",
    thanks: "Faleminderit!",
    lede: "Porosia juaj u regjistrua. Stafi ynë do t'ju telefonojë për ta konfirmuar dhe për t'ju thënë kur arrin dërgesa.",
    orderNumber: "Numri i porosisë",
    keepNumber:
      "Ruajeni këtë numër. Nëse keni pyetje, na telefononi në {{phone}} dhe përmendni atë.",
    continue: "Vazhdo blerjen",
    home: "Kthehu në ballinë",
  },

  sample: {
    kicker: "Kërkesë për mostër",
    explain:
      "Mostrat u dedikohen artistëve dhe studiove profesionale, prandaj dërgohen vetëm pas verifikimit. Plotësoni të dhënat e biznesit tuaj dhe ju kontaktojmë sa më shpejt.",
    business: "Emri i studios / biznesit",
    contactName: "Personi i kontaktit",
    phone: "Numri i telefonit",
    instagram: "Instagram i biznesit",
    email: "Email",
    city: "Qyteti",
    note: "Shënim",
    notePlaceholder: "Çfarë punoni më shpesh, sa klientë keni në javë…",
    submit: "Dërgo kërkesën",
    disclaimer:
      "Kërkesa nuk është porosi. Mostra dërgohet vetëm pas konfirmimit tonë.",
    sentTitle: "Kërkesa u dërgua",
    sentBody:
      "Faleminderit. Do të shqyrtojmë kërkesën tuaj dhe do t'ju kontaktojmë në numrin që latë për të konfirmuar dërgesën e mostrës.",
    errBusiness: "Shkruani emrin e studios ose biznesit.",
    errName: "Shkruani emrin tuaj.",
    errPhone: "Numri duhet të jetë si 044 123 456.",
    errEmail: "Shkruani një email të vlefshëm.",
    errInstagram: "Shkruani profilin tuaj në Instagram.",
  },

  about: {
    eyebrow: "Rreth nesh",
    title: "Kaida Beauty Studio",
    lede: "Distributor i autorizuar zyrtarisht i markës LaBina® për Kosovë — ngjyra pigmentimi për Permanent Make-up dhe Microblading, të prodhuara në Gjermani.",
    brandEyebrow: "Marka",
    brandTitle: "Prodhuar në Gjermani që nga viti 2004",
    p1: "Ngjyrat e pigmentimit LaBina® zhvillohen nga PERMANENT-Line dhe shpërndahen në mbarë botën nga PERMANENT-Line GmbH & Co. KG me seli në Bad Arolsen, Gjermani. Prodhimi bëhet në një laborator gjerman i specializuar në ngjyra për tatuazhe dhe pigmentim që nga viti 1996.",
    p2: "Formula nuk përmban pigmente të oksidit të hekurit dhe as akrilate. Ngjyrat hidhen në treg pa konservues dhe pa organizma të aftë për të mbijetuar, çka do të thotë se — kur përdoren siç duhet — mbeten pa mikrobe edhe pas hapjes së shishes.",
    p3: "Ne e sjellim këtë cilësi në Kosovë dhe qëndrojmë pranë artistëve që e përdorin: nga zgjedhja e nuancës së duhur deri te furnizimi i rregullt.",
    safetyEyebrow: "Siguria",
    safetyTitle: "Çfarë qëndron pas çdo shisheje",
    standards: [
      {
        title: "Rregullorja (BE) 2020/2081",
        body: "Çdo ngjyrë ka deklaratë konformiteti dhe përmbledhje analize, të disponueshme edhe për klientin përfundimtar.",
      },
      {
        title: "REACH",
        body: "Në përputhje me kërkesat ligjore të vlefshme në të gjitha vendet e Bashkimit Evropian.",
      },
      {
        title: "Testim para çdo serie",
        body: "Lëndët e para analizohen nga laboratorë kimiko-teknikë përpara përdorimit të parë, sipas 18 parametrave.",
      },
      {
        title: "Sterilizim me rreze gama",
        body: "Ngjyrat përzihen nën vakum dhe bluhen pa kontakt me ajrin për të shmangur kontaminimin.",
      },
    ],
    ctaTitle: "Nuk jeni të sigurt për nuancën?",
    ctaText:
      "Na tregoni tipin e lëkurës dhe rezultatin që kërkon klientja juaj, dhe ju ndihmojmë ta zgjidhni nuancën e duhur para se të porosisni.",
    ctaButton: "Na kontaktoni",
  },

  contact: {
    eyebrow: "Kontakt",
    title: "Na shkruani",
    lede: "Për porosi, disponueshmëri të produkteve ose këshilla për zgjedhjen e ngjyrës — na kontaktoni direkt. Përgjigjemi brenda ditës së punës.",
    whatsapp: "WhatsApp",
    whatsappHint: "Mënyra më e shpejtë për të porositur",
    phone: "Telefon",
    phoneHint: "E hënë – e shtunë",
    email: "Email",
    instagram: "Instagram",
    address: "Adresa",
    company: "Kompania",
  },

  footer: {
    tagline:
      "Distributor i autorizuar zyrtarisht i markës LaBina® për Kosovë. Ngjyra pigmentimi për Permanent Make-up dhe Microblading, të prodhuara në Gjermani.",
    pages: "Faqet",
    contact: "Kontakti",
    rights: "Të gjitha të drejtat e rezervuara.",
    builtBy: "Ndërtuar nga",
  },

  notFound: {
    title: "Kjo faqe nuk ekziston",
    body: "Linku mund të jetë i gabuar ose faqja është hequr.",
    products: "Shiko produktet",
    home: "Kthehu në ballinë",
  },
};

const en = {
  lang: { sq: "Albanian", en: "English", de: "German" },

  nav: {
    home: "Home",
    products: "Products",
    studio: "Studio",
    about: "About",
    contact: "Contact",
    cart: "Cart",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    tagline: "Exclusive LaBina® distributor for Kosovo",
    language: "Choose language",
  },

  common: {
    loading: "Loading…",
    tryAgain: "Try again",
    clearFilters: "Clear filters",
    showMore: "Show more",
    allShown: "All {{count}} products are shown.",
    ofProducts: "{{shown}} of {{total}} products",
    product: "product",
    products: "products",
    optional: "(optional)",
    close: "Close",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending…",
    back: "Back",
  },

  home: {
    heroLine1: "German",
    heroLine2: "pigments.",
    heroLine3a: "Albanian",
    heroLine3b: "hands.",
    heroLead:
      "Exclusive LaBina® distributor for Kosovo — and a studio that works every day with the very products it sells.",
    heroShop: "Shop",
    heroStudio: "Studio",
    statement1:
      "We supply Kosovo's artists with original pigments, needles and materials from Germany.",
    statement2: "And we use them ourselves, every day, in our own studio.",
    facts: {
      since: "German-made since",
      params: "Laboratory parameters",
      iron: "Iron oxides",
      preservatives: "Free of chemical preservatives",
    },
    shopEyebrow: "Shop",
    shopTitle: "Find what you need",
    seeAll: "All products",
    noResults: "No product matches your search.",
    ctaTitle1: "Not sure which",
    ctaTitle2: "shade to pick?",
    ctaText:
      "Tell us the skin type and the result your client is after. We'll help you choose before you order.",
    ctaButton: "Get in touch",
  },

  studio: {
    introKicker: "Kaida Beauty Studio",
    introTitle1: "We're not just",
    introTitle2: "a supplier.",
    introText:
      "We're a studio working with these products every day. That's why we know exactly what we recommend.",
    hint: "Keep scrolling",
    kickerStudio: "Studio",
    kickerShop: "Shop",
    book: "Book an appointment",
    seeShop: "Visit the shop",
    lashes: {
      title: "Lashes",
      lead: "Classic, Hybrid and Volume — applied lash by lash.",
      body: "We work with materials we know inside out, because they're the same ones we supply to other artists. No compromise on adhesive, no damage to the natural lash.",
      tags: ["Classic", "Hybrid", "Volume", "Refill"],
    },
    brows: {
      title: "Brows",
      lead: "Microblading, Powder Brows and combination techniques.",
      body: "The shade is chosen for the skin tone and natural hair colour — from the same LaBina® colour chart we sell. The result fades naturally, without turning red or grey.",
      tags: ["Microblading", "Powder Brows", "Combo", "Correction"],
    },
    nails: {
      title: "Nails",
      lead: "Manicure, gel and extensions — clean work that lasts.",
      body: "We don't sell nail supplies in the shop; this service is offered inside the studio only. Same hygiene standard and same care as every other service.",
      tags: ["Manicure", "Gel", "Extensions", "Design"],
      note: "Studio service only",
    },
    shop: {
      title: "The same products",
      lead: "What we use for lashes and brows, you'll find in the shop.",
      body: "We don't sell anything we don't use ourselves. The pigments, needles and materials are original, come with a declaration of conformity and are tested before every batch.",
      tags: ["Pigments", "Needles", "Materials"],
    },
  },

  filters: {
    searchPlaceholder: "Search product or code",
    searchLabel: "Search products",
    clearSearch: "Clear search",
    categoryGroup: "Filter by category",
    all: "All",
    sortLabel: "Sort products",
    sortCode: "By code",
    sortName: "By name",
    sortPriceAsc: "Price: low to high",
    sortPriceDesc: "Price: high to low",
  },

  shop: {
    eyebrow: "Catalogue",
    title: "The colour chart",
    lede: "Every product carries its manufacturer code. Search by name or by code.",
    loadFailed: "Products failed to load.",
    noResultsFor: 'No results for "{{query}}".',
    emptyCategory: "No products in this category yet.",
    showMoreCount: "Show more ({{count}})",
  },

  product: {
    addToCart: "Add to cart",
    added: "Added",
    orderNow: "Order now",
    viewProduct: "View product",
    requestSample: "Request a sample",
    sampleBadge: "Sample",
    sampleOnRequest: "By request only",
    sampleFree: "Free for professionals",
    sampleNote: "Sample — by request only",
    sampleExplain:
      "Samples are intended for professional artists and studios. Send a request with your business details and we'll get in touch to confirm.",
    inStock: "In stock",
    lowStock: "Only {{count}} left",
    lowStockLong: "Only {{count}} left in stock",
    outOfStock: "Currently out of stock",
    outTitle: "This product is currently out of stock.",
    outBody:
      "The next delivery is on its way. {{link}} or message us on WhatsApp and we'll let you know as soon as it's back.",
    outLink: "Write to us",
    notFound: "Product not found",
    notFoundBody: "This product may have been removed, or the link is wrong.",
    backToProducts: "Back to products",
    related: "Similar products",
    decrease: "Decrease quantity",
    increase: "Increase quantity",
    assurancePay: "Payment is made in cash on delivery.",
    assuranceShip: "Delivery across Kosovo.",
    assuranceOriginal: "Original product with declaration of conformity.",
    assuranceReview: "Your request is reviewed by our staff before dispatch.",
    assuranceContact: "We'll call you on the number you leave in the form.",
  },

  cart: {
    title: "Cart",
    empty: "Your cart is empty.",
    seeProducts: "Browse products",
    remove: "Remove from cart",
    removeShort: "Remove",
    maxStock: "Maximum in stock: {{count}}",
    total: "Total",
    shippingNote: "Shipping is calculated during checkout.",
    checkout: "Continue to checkout",
  },

  checkout: {
    eyebrow: "Checkout",
    title: "Complete your order",
    lede: "No card needed. You pay in cash when your order arrives.",
    emptyTitle: "Your cart is empty",
    emptyBody:
      "Add the products you need and come back here to finish your order.",
    yourDetails: "Your details",
    name: "Full name",
    phone: "Phone number",
    email: "Email",
    city: "City",
    address: "Full address",
    addressPlaceholder: "Street, number, entrance",
    note: "Note",
    notePlaceholder: "When you're home, delivery instructions…",
    submit: "Place order",
    consent:
      "By placing the order, you agree that our staff may call you to confirm.",
    summary: "Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    shippingValue: "Confirmed by phone",
    stockChanged: "Stock changed in the meantime.",
    stockLine: "{{name}}: you asked for {{requested}}, {{available}} left.",
    stockFix: "Adjust the quantities below and try again.",
    failed: "The order wasn't sent. Please try again or call us.",
    errName: "Enter your full name.",
    errPhone: "The number should look like 044 123 456.",
    errEmail: "That email doesn't look right.",
    errCity: "Enter your city.",
    errAddress: "Enter your full address.",
    qtyFor: "Quantity for {{name}}",
  },

  success: {
    thanksNamed: "Thank you, {{name}}!",
    thanks: "Thank you!",
    lede: "Your order has been registered. Our staff will call you to confirm it and let you know when the delivery arrives.",
    orderNumber: "Order number",
    keepNumber:
      "Keep this number. If you have questions, call us on {{phone}} and mention it.",
    continue: "Continue shopping",
    home: "Back to home",
  },

  sample: {
    kicker: "Sample request",
    explain:
      "Samples are intended for professional artists and studios, so they're only sent after verification. Fill in your business details and we'll be in touch shortly.",
    business: "Studio / business name",
    contactName: "Contact person",
    phone: "Phone number",
    instagram: "Business Instagram",
    email: "Email",
    city: "City",
    note: "Note",
    notePlaceholder: "What you work on most, how many clients a week…",
    submit: "Send request",
    disclaimer:
      "A request is not an order. The sample ships only after we confirm.",
    sentTitle: "Request sent",
    sentBody:
      "Thank you. We'll review your request and call you on the number you left to confirm the sample.",
    errBusiness: "Enter your studio or business name.",
    errName: "Enter your name.",
    errPhone: "The number should look like 044 123 456.",
    errEmail: "Enter a valid email.",
    errInstagram: "Enter your Instagram profile.",
  },

  about: {
    eyebrow: "About us",
    title: "Kaida Beauty Studio",
    lede: "Officially authorised distributor of LaBina® for Kosovo — pigment colours for Permanent Make-up and Microblading, made in Germany.",
    brandEyebrow: "The brand",
    brandTitle: "Made in Germany since 2004",
    p1: "LaBina® pigment colours are developed by PERMANENT-Line and distributed worldwide by PERMANENT-Line GmbH & Co. KG, based in Bad Arolsen, Germany. Production takes place in a German laboratory that has specialised in tattoo and pigmentation colours since 1996.",
    p2: "The formula contains no iron oxide pigments and no acrylates. The colours go to market without preservatives and without viable organisms, which means that — used correctly — they stay free of microbes even after the bottle is opened.",
    p3: "We bring that quality to Kosovo and stay close to the artists who use it: from choosing the right shade to keeping you supplied.",
    safetyEyebrow: "Safety",
    safetyTitle: "What stands behind every bottle",
    standards: [
      {
        title: "Regulation (EU) 2020/2081",
        body: "Every colour has a declaration of conformity and an analysis summary, available to the end client as well.",
      },
      {
        title: "REACH",
        body: "Compliant with the legal requirements in force across all European Union countries.",
      },
      {
        title: "Tested before every batch",
        body: "Raw materials are analysed by chemical-technical laboratories before first use, across 18 parameters.",
      },
      {
        title: "Gamma sterilisation",
        body: "Colours are mixed under vacuum and milled without air contact to avoid contamination.",
      },
    ],
    ctaTitle: "Not sure which shade to pick?",
    ctaText:
      "Tell us the skin type and the result your client is after, and we'll help you choose the right shade before you order.",
    ctaButton: "Get in touch",
  },

  contact: {
    eyebrow: "Contact",
    title: "Write to us",
    lede: "For orders, product availability or advice on choosing a shade — contact us directly. We reply within the working day.",
    whatsapp: "WhatsApp",
    whatsappHint: "The fastest way to order",
    phone: "Phone",
    phoneHint: "Monday – Saturday",
    email: "Email",
    instagram: "Instagram",
    address: "Address",
    company: "Company",
  },

  footer: {
    tagline:
      "Officially authorised distributor of LaBina® for Kosovo. Pigment colours for Permanent Make-up and Microblading, made in Germany.",
    pages: "Pages",
    contact: "Contact",
    rights: "All rights reserved.",
    builtBy: "Built by",
  },

  notFound: {
    title: "This page doesn't exist",
    body: "The link may be wrong, or the page has been removed.",
    products: "Browse products",
    home: "Back to home",
  },
};

const de = {
  lang: { sq: "Albanisch", en: "Englisch", de: "Deutsch" },

  nav: {
    home: "Startseite",
    products: "Produkte",
    studio: "Studio",
    about: "Über uns",
    contact: "Kontakt",
    cart: "Warenkorb",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    tagline: "Exklusiver LaBina®-Distributor für den Kosovo",
    language: "Sprache wählen",
  },

  common: {
    loading: "Wird geladen…",
    tryAgain: "Erneut versuchen",
    clearFilters: "Filter zurücksetzen",
    showMore: "Mehr anzeigen",
    allShown: "Alle {{count}} Produkte werden angezeigt.",
    ofProducts: "{{shown}} von {{total}} Produkten",
    product: "Produkt",
    products: "Produkte",
    optional: "(optional)",
    close: "Schließen",
    cancel: "Abbrechen",
    send: "Senden",
    sending: "Wird gesendet…",
    back: "Zurück",
  },

  home: {
    heroLine1: "Deutsche",
    heroLine2: "Pigmente.",
    heroLine3a: "Albanische",
    heroLine3b: "Hände.",
    heroLead:
      "Exklusiver LaBina®-Distributor für den Kosovo — und ein Studio, das täglich mit genau den Produkten arbeitet, die es verkauft.",
    heroShop: "Shop",
    heroStudio: "Studio",
    statement1:
      "Wir beliefern die Artists im Kosovo mit originalen Pigmenten, Nadeln und Materialien aus Deutschland.",
    statement2: "Und wir verwenden sie selbst, jeden Tag, in unserem Studio.",
    facts: {
      since: "Deutsche Produktion seit",
      params: "Laborparameter",
      iron: "Eisenoxide",
      preservatives: "Ohne chemische Konservierungsstoffe",
    },
    shopEyebrow: "Shop",
    shopTitle: "Finden Sie, was Sie brauchen",
    seeAll: "Alle Produkte",
    noResults: "Kein Produkt passt zu Ihrer Suche.",
    ctaTitle1: "Unsicher bei",
    ctaTitle2: "der Nuance?",
    ctaText:
      "Sagen Sie uns den Hauttyp und das gewünschte Ergebnis Ihrer Kundin. Wir helfen Ihnen bei der Auswahl, bevor Sie bestellen.",
    ctaButton: "Kontakt aufnehmen",
  },

  studio: {
    introKicker: "Kaida Beauty Studio",
    introTitle1: "Wir sind nicht nur",
    introTitle2: "Lieferant.",
    introText:
      "Wir sind ein Studio, das täglich mit diesen Produkten arbeitet. Deshalb wissen wir genau, was wir empfehlen.",
    hint: "Weiter scrollen",
    kickerStudio: "Studio",
    kickerShop: "Shop",
    book: "Termin buchen",
    seeShop: "Zum Shop",
    lashes: {
      title: "Wimpern",
      lead: "Classic, Hybrid und Volume — Wimper für Wimper aufgetragen.",
      body: "Wir arbeiten mit Materialien, die wir bis ins Detail kennen, denn es sind dieselben, die wir anderen Artists liefern. Kein Kompromiss beim Kleber, keine Schädigung der Naturwimper.",
      tags: ["Classic", "Hybrid", "Volume", "Refill"],
    },
    brows: {
      title: "Augenbrauen",
      lead: "Microblading, Powder Brows und Kombinationstechniken.",
      body: "Die Nuance wird nach Hautton und natürlicher Haarfarbe gewählt — aus derselben LaBina®-Farbkarte, die wir verkaufen. Das Ergebnis verblasst natürlich, ohne ins Rote oder Graue zu kippen.",
      tags: ["Microblading", "Powder Brows", "Combo", "Korrektur"],
    },
    nails: {
      title: "Nägel",
      lead: "Maniküre, Gel und Modellage — saubere Arbeit, die hält.",
      body: "Nagelmaterialien verkaufen wir nicht im Shop; diesen Service bieten wir ausschließlich im Studio an. Gleicher Hygienestandard und gleiche Sorgfalt wie bei jeder anderen Behandlung.",
      tags: ["Maniküre", "Gel", "Modellage", "Design"],
      note: "Nur als Studio-Service",
    },
    shop: {
      title: "Dieselben Produkte",
      lead: "Was wir für Wimpern und Brauen verwenden, finden Sie im Shop.",
      body: "Wir verkaufen nichts, was wir nicht selbst verwenden. Pigmente, Nadeln und Materialien sind original, mit Konformitätserklärung und vor jeder Charge geprüft.",
      tags: ["Pigmente", "Nadeln", "Materialien"],
    },
  },

  filters: {
    searchPlaceholder: "Produkt oder Code suchen",
    searchLabel: "Produkte suchen",
    clearSearch: "Suche löschen",
    categoryGroup: "Nach Kategorie filtern",
    all: "Alle",
    sortLabel: "Produkte sortieren",
    sortCode: "Nach Code",
    sortName: "Nach Name",
    sortPriceAsc: "Preis: aufsteigend",
    sortPriceDesc: "Preis: absteigend",
  },

  shop: {
    eyebrow: "Katalog",
    title: "Die Farbkarte",
    lede: "Jedes Produkt trägt seinen Herstellercode. Suchen Sie nach Name oder Code.",
    loadFailed: "Produkte konnten nicht geladen werden.",
    noResultsFor: 'Keine Ergebnisse für "{{query}}".',
    emptyCategory: "In dieser Kategorie gibt es noch keine Produkte.",
    showMoreCount: "Mehr anzeigen ({{count}})",
  },

  product: {
    addToCart: "In den Warenkorb",
    added: "Hinzugefügt",
    orderNow: "Jetzt bestellen",
    viewProduct: "Produkt ansehen",
    requestSample: "Muster anfragen",
    sampleBadge: "Muster",
    sampleOnRequest: "Nur auf Anfrage",
    sampleFree: "Kostenlos für Profis",
    sampleNote: "Muster — nur auf Anfrage",
    sampleExplain:
      "Muster sind für professionelle Artists und Studios gedacht. Senden Sie eine Anfrage mit Ihren Geschäftsdaten und wir melden uns zur Bestätigung.",
    inStock: "Auf Lager",
    lowStock: "Nur noch {{count}}",
    lowStockLong: "Nur noch {{count}} auf Lager",
    outOfStock: "Derzeit nicht auf Lager",
    outTitle: "Dieses Produkt ist derzeit ausverkauft.",
    outBody:
      "Die nächste Lieferung ist unterwegs. {{link}} oder schreiben Sie uns auf WhatsApp — wir melden uns, sobald es wieder da ist.",
    outLink: "Schreiben Sie uns",
    notFound: "Produkt nicht gefunden",
    notFoundBody:
      "Dieses Produkt wurde möglicherweise entfernt oder der Link ist falsch.",
    backToProducts: "Zurück zu den Produkten",
    related: "Ähnliche Produkte",
    decrease: "Menge verringern",
    increase: "Menge erhöhen",
    assurancePay: "Die Zahlung erfolgt bar bei Lieferung.",
    assuranceShip: "Lieferung in den gesamten Kosovo.",
    assuranceOriginal: "Originalprodukt mit Konformitätserklärung.",
    assuranceReview: "Ihre Anfrage wird vor dem Versand von uns geprüft.",
    assuranceContact: "Wir rufen Sie unter der angegebenen Nummer an.",
  },

  cart: {
    title: "Warenkorb",
    empty: "Ihr Warenkorb ist leer.",
    seeProducts: "Produkte ansehen",
    remove: "Aus dem Warenkorb entfernen",
    removeShort: "Entfernen",
    maxStock: "Maximal auf Lager: {{count}}",
    total: "Gesamt",
    shippingNote: "Der Versand wird bei der Bestellung berechnet.",
    checkout: "Zur Bestellung",
  },

  checkout: {
    eyebrow: "Bestellung",
    title: "Bestellung abschließen",
    lede: "Keine Karte nötig. Sie zahlen bar bei Erhalt der Bestellung.",
    emptyTitle: "Ihr Warenkorb ist leer",
    emptyBody:
      "Legen Sie die gewünschten Produkte hinein und kommen Sie hierher zurück.",
    yourDetails: "Ihre Angaben",
    name: "Vor- und Nachname",
    phone: "Telefonnummer",
    email: "E-Mail",
    city: "Stadt",
    address: "Vollständige Adresse",
    addressPlaceholder: "Straße, Nummer, Eingang",
    note: "Anmerkung",
    notePlaceholder: "Wann Sie zu Hause sind, Lieferhinweise…",
    submit: "Bestellung senden",
    consent:
      "Mit dem Absenden stimmen Sie zu, dass unser Team Sie zur Bestätigung anruft.",
    summary: "Übersicht",
    subtotal: "Zwischensumme",
    shipping: "Versand",
    shippingValue: "Wird telefonisch bestätigt",
    stockChanged: "Der Lagerbestand hat sich zwischenzeitlich geändert.",
    stockLine: "{{name}}: angefragt {{requested}}, verfügbar {{available}}.",
    stockFix: "Passen Sie die Mengen unten an und versuchen Sie es erneut.",
    failed:
      "Die Bestellung wurde nicht gesendet. Bitte erneut versuchen oder anrufen.",
    errName: "Bitte Vor- und Nachnamen eingeben.",
    errPhone: "Die Nummer sollte wie 044 123 456 aussehen.",
    errEmail: "Diese E-Mail sieht nicht korrekt aus.",
    errCity: "Bitte Stadt eingeben.",
    errAddress: "Bitte vollständige Adresse eingeben.",
    qtyFor: "Menge für {{name}}",
  },

  success: {
    thanksNamed: "Vielen Dank, {{name}}!",
    thanks: "Vielen Dank!",
    lede: "Ihre Bestellung ist eingegangen. Unser Team ruft Sie zur Bestätigung an und sagt Ihnen, wann die Lieferung eintrifft.",
    orderNumber: "Bestellnummer",
    keepNumber:
      "Bewahren Sie diese Nummer auf. Bei Fragen rufen Sie uns unter {{phone}} an und nennen Sie sie.",
    continue: "Weiter einkaufen",
    home: "Zur Startseite",
  },

  sample: {
    kicker: "Musteranfrage",
    explain:
      "Muster sind für professionelle Artists und Studios gedacht und werden erst nach Prüfung versendet. Füllen Sie Ihre Geschäftsdaten aus und wir melden uns kurzfristig.",
    business: "Studio- / Firmenname",
    contactName: "Ansprechpartner",
    phone: "Telefonnummer",
    instagram: "Instagram des Geschäfts",
    email: "E-Mail",
    city: "Stadt",
    note: "Anmerkung",
    notePlaceholder:
      "Woran Sie am häufigsten arbeiten, wie viele Kundinnen pro Woche…",
    submit: "Anfrage senden",
    disclaimer:
      "Eine Anfrage ist keine Bestellung. Das Muster wird erst nach unserer Bestätigung versendet.",
    sentTitle: "Anfrage gesendet",
    sentBody:
      "Vielen Dank. Wir prüfen Ihre Anfrage und rufen Sie unter der angegebenen Nummer an, um den Versand des Musters zu bestätigen.",
    errBusiness: "Bitte Studio- oder Firmennamen eingeben.",
    errName: "Bitte Ihren Namen eingeben.",
    errPhone: "Die Nummer sollte wie 044 123 456 aussehen.",
    errEmail: "Bitte eine gültige E-Mail eingeben.",
    errInstagram: "Bitte Ihr Instagram-Profil eingeben.",
  },

  about: {
    eyebrow: "Über uns",
    title: "Kaida Beauty Studio",
    lede: "Offiziell autorisierter LaBina®-Distributor für den Kosovo — Pigmentfarben für Permanent Make-up und Microblading, hergestellt in Deutschland.",
    brandEyebrow: "Die Marke",
    brandTitle: "Hergestellt in Deutschland seit 2004",
    p1: "LaBina®-Pigmentfarben werden von PERMANENT-Line entwickelt und weltweit von der PERMANENT-Line GmbH & Co. KG mit Sitz in Bad Arolsen vertrieben. Die Produktion erfolgt in einem deutschen Labor, das seit 1996 auf Tattoo- und Pigmentierfarben spezialisiert ist.",
    p2: "Die Rezeptur enthält weder Eisenoxidpigmente noch Acrylate. Die Farben kommen ohne Konservierungsstoffe und ohne überlebensfähige Organismen in den Handel — bei korrekter Anwendung bleiben sie auch nach dem Öffnen keimfrei.",
    p3: "Wir bringen diese Qualität in den Kosovo und bleiben nah an den Artists, die sie verwenden: von der Wahl der richtigen Nuance bis zur regelmäßigen Belieferung.",
    safetyEyebrow: "Sicherheit",
    safetyTitle: "Was hinter jeder Flasche steht",
    standards: [
      {
        title: "Verordnung (EU) 2020/2081",
        body: "Zu jeder Farbe gibt es eine Konformitätserklärung und eine Analysenzusammenfassung, auch für Endkundinnen einsehbar.",
      },
      {
        title: "REACH",
        body: "Konform mit den in allen Ländern der Europäischen Union geltenden gesetzlichen Anforderungen.",
      },
      {
        title: "Prüfung vor jeder Charge",
        body: "Rohstoffe werden vor dem ersten Einsatz von chemisch-technischen Laboren nach 18 Parametern analysiert.",
      },
      {
        title: "Gammasterilisation",
        body: "Die Farben werden unter Vakuum gemischt und ohne Luftkontakt gemahlen, um Kontamination zu vermeiden.",
      },
    ],
    ctaTitle: "Unsicher bei der Nuance?",
    ctaText:
      "Sagen Sie uns den Hauttyp und das gewünschte Ergebnis Ihrer Kundin, und wir helfen Ihnen, die richtige Nuance zu wählen, bevor Sie bestellen.",
    ctaButton: "Kontakt aufnehmen",
  },

  contact: {
    eyebrow: "Kontakt",
    title: "Schreiben Sie uns",
    lede: "Für Bestellungen, Verfügbarkeit oder Beratung zur Farbwahl — kontaktieren Sie uns direkt. Wir antworten innerhalb des Arbeitstages.",
    whatsapp: "WhatsApp",
    whatsappHint: "Der schnellste Weg zu bestellen",
    phone: "Telefon",
    phoneHint: "Montag – Samstag",
    email: "E-Mail",
    instagram: "Instagram",
    address: "Adresse",
    company: "Unternehmen",
  },

  footer: {
    tagline:
      "Offiziell autorisierter LaBina®-Distributor für den Kosovo. Pigmentfarben für Permanent Make-up und Microblading, hergestellt in Deutschland.",
    pages: "Seiten",
    contact: "Kontakt",
    rights: "Alle Rechte vorbehalten.",
    builtBy: "Erstellt von",
  },

  notFound: {
    title: "Diese Seite existiert nicht",
    body: "Der Link ist möglicherweise falsch oder die Seite wurde entfernt.",
    products: "Produkte ansehen",
    home: "Zur Startseite",
  },
};

export const LANGUAGES = [
  { code: "sq", label: "SQ", name: "Shqip" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
];

export const DEFAULT_LANG = "sq";

const translations = { sq, en, de };

export default translations;
